import { t } from 'i18next'

import { pickNtbColumns } from '~/modules/retailMedia/helpers/ntbMetrics'

import { MetricTooltip } from '../../../../MetricMethodologyTooltip'
import { commonColumns } from '../columns'
import { cost } from '../elements/cost'
import { pickColumn } from '../helpers'

export const objectiveBasedColumns = (params: SchemaProps) => {
  const columns = commonColumns(
    params?.availableMetrics,
    undefined,
    params?.campaignAdType,
    params?.lookbackMonths,
    params?.ntbOrdersWindow
  )

  /**
   * CPC / CPM — em campanhas por objetivo o bid é automático:
   * CPC fica visível apenas para super admin
   */
  const { CPC, ...costColumns } = cost({
    campaignAdType: params.campaignAdType,
    strategy: params.strategy,
    superAdmin: params.superAdmin,
    insideCampaign: params.insideCampaign
  })

  return {
    title: columns.title,
    status: columns.status,
    impressions: columns.impressions,
    views: columns.views,
    clicks: columns.clicks,
    ...(params.superAdmin && CPC ? { CPC } : {}),
    ...costColumns,

    ctr: columns.ctr,
    totalSpent: columns.totalSpent,

    /**
     * Campanhas por objetivo seguem atribuindo conversões apenas a cliques:
     * o tooltip não deve citar a metodologia de clique + visualização
     */
    conversion: {
      ...columns.conversion,
      helpText: t('rm:metrics.conversionsObjectiveBased.tooltip')
    },
    conversion_rate: {
      ...columns.conversion_rate,
      helpContent: <MetricTooltip metric="conversionRateObjectiveBased" />
    },
    total_sales: columns.total_sales,
    total_conversions_items_quantity: columns.total_conversions_items_quantity,
    halo_orders: columns.halo_orders,
    halo_revenue: columns.halo_revenue,
    halo_items: columns.halo_items,
    ...(params.availableMetrics?.impressionShare
      ? { impressionShare: columns.impressionShare }
      : {}),
    ...(params.availableMetrics?.lostIsRank
      ? { lostIsRank: columns.lostIsRank }
      : {}),
    ...pickColumn(
      params.availableMetrics?.lostIsBudget,
      'lostIsBudget',
      columns
    ),
    // commonColumns já filtrou pelas métricas disponíveis
    ...pickNtbColumns(columns)
  }
}
